<template>
	<g clip-path="url(#clip0_7972_9598)">
		<path d="M10 12.667L8 14.667L6 12.667" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M12.666 6L14.666 8L12.666 10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M3.33398 6L1.33398 8L3.33398 10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M1.33398 8H14.6673" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M6 3.33301L8 1.33301L10 3.33301" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
		<path d="M8 1.33301V14.6663" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
	</g>
	<defs>
		<clipPath id="clip0_7972_9598">
			<rect width="16" height="16" fill="white"/>
		</clipPath>
	</defs>
</template>
